import { c as _c } from "react/compiler-runtime";
import { LazyImage } from "@website/ui/lazy-image";
import { useEffect, useState } from "react";
import type { VillaHostFeatureFocusScrollerProperties } from "./VillaHostFeatureFocusScroller.types";
const AUTO_SCROLL_INTERVAL_IN_MS = 4000;
const wrap = (value: number, length: number) => {
  if (length === 0) return 0;
  return (value % length + length) % length;
};
const getVisibleItemIndexes = (activeIndex: number, itemCount: number) => {
  const maxVisibleDistance = Math.floor((itemCount - 1) / 2);
  const renderRadius = maxVisibleDistance + 1;
  return Array.from({
    length: renderRadius * 2 + 1
  }, (_, index) => activeIndex - renderRadius + index);
};
const getDistanceStyle = (distance: number, maxVisibleDistance: number) => {
  if (distance === 0 || distance > maxVisibleDistance) {
    return {
      opacity: 0,
      blur: 2.2,
      scale: 0.92
    };
  }
  if (distance === 1) {
    return {
      opacity: 0.68,
      blur: 0.5,
      scale: 0.98
    };
  }
  if (distance === 2) {
    return {
      opacity: 0.42,
      blur: 1.2,
      scale: 0.95
    };
  }
  return {
    opacity: 0.22,
    blur: 2,
    scale: 0.92
  };
};
const getItemOffset = (circularOffset: number) => {
  const distance = Math.abs(circularOffset);
  if (distance === 0) return 0;

  // Space between active item and nearest items
  const spacingFromActive = 72;

  // Space between inactive items
  const spacingBetweenItems = 36;
  return circularOffset > 0 ? spacingFromActive + (distance - 1) * spacingBetweenItems : -(spacingFromActive + (distance - 1) * spacingBetweenItems);
};
const titlePositionClassName = "absolute left-1/2 top-1/2 min-w-max -translate-y-1/2 text-left max-lg:-translate-x-[60%] lg:-translate-x-1/2";
const Component = t0 => {
  const $ = _c(23);
  const {
    features
  } = t0;
  const itemCount = features.length;
  const [activeIndex, setActiveIndex] = useState(_temp);
  let t1;
  let t2;
  if ($[0] !== itemCount) {
    t1 = () => {
      if (itemCount <= 1) {
        return;
      }
      const intervalId = window.setInterval(() => {
        setActiveIndex(_temp2);
      }, AUTO_SCROLL_INTERVAL_IN_MS);
      return () => window.clearInterval(intervalId);
    };
    t2 = [itemCount];
    $[0] = itemCount;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const activeFeature = itemCount > 0 ? features[wrap(activeIndex, itemCount)] : null;
  const maxVisibleDistance = Math.floor((itemCount - 1) / 2);
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[3] !== activeIndex || $[4] !== features || $[5] !== itemCount || $[6] !== maxVisibleDistance) {
    const visibleItemIndexes = itemCount > 0 ? getVisibleItemIndexes(activeIndex, itemCount) : [];
    t5 = "\u0648\u06CC\u0698\u06AF\u06CC\u200C\u0647\u0627\u06CC \u067E\u0646\u0644 \u0645\u06CC\u0632\u0628\u0627\u0646";
    t6 = "relative mx-auto h-[400px] w-full max-w-[560px] overflow-hidden rounded-[28px] text-center outline-none";
    t7 = "rtl";
    t3 = "relative z-10 h-full";
    t4 = visibleItemIndexes.map(virtualIndex => {
      const item = features[wrap(virtualIndex, itemCount)];
      const offsetFromActive = virtualIndex - activeIndex;
      const distance = Math.abs(offsetFromActive);
      const offset = getItemOffset(offsetFromActive);
      const {
        opacity,
        blur,
        scale
      } = getDistanceStyle(distance, maxVisibleDistance);
      return <li className="absolute inset-x-0 h-8 px-4 transition-[opacity,filter,transform] duration-[560ms] ease-[cubic-bezier(0.22,1,0.36,1)] sm:px-6" key={virtualIndex} style={{
        opacity,
        filter: `blur(${blur}px)`,
        top: "50%",
        transform: `translate3d(0, calc(-50% + ${offset}px), 0) scale(${scale})`
      }}><p className={`${titlePositionClassName} text-base font-bold`}>{item.title}</p></li>;
    });
    $[3] = activeIndex;
    $[4] = features;
    $[5] = itemCount;
    $[6] = maxVisibleDistance;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t3 || $[13] !== t4) {
    t8 = <ul className={t3}>{t4}</ul>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== activeFeature) {
    t9 = activeFeature && <div className="absolute inset-x-0 top-1/2 z-20 m-auto w-[98%] -translate-y-1/2 lg:w-[90%] lg:px-6"><div className="border-outline-thin relative h-16 overflow-hidden rounded-[20px] border bg-white px-4 lg:px-6" style={{
        boxShadow: "0px 3px 3px -2px #00000033, 0px 3px 4px 0px #00000024, 0px 1px 8px 0px #0000001F"
      }}><div className="absolute inset-x-0 top-1/2 flex h-16 -translate-y-1/2 items-center"><span className="flex items-center justify-center pr-6"><LazyImage src={activeFeature.icon} className="!size-11 max-h-full max-w-full lg:!size-14" /></span><p className={`text-on-surface-high-emphasis ${titlePositionClassName} text-base font-bold lg:text-xl`}>{activeFeature.title}</p></div></div></div>;
    $[15] = activeFeature;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8 || $[21] !== t9) {
    t10 = <div aria-label={t5} className={t6} dir={t7}>{t8}{t9}</div>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
};
export const VillaHostFeatureFocusScroller = Component;
function _temp() {
  return 4;
}
function _temp2(previous) {
  return previous + 1;
}